const namespace = "ringRegistrationError";

export const NO_TABLE_FOUND = `${namespace}.noTableFound`;
